module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: _vm._inputBoxStyle
  }, [_c('div', {
    staticClass: ["inputBox"],
    style: {
      borderRadius: _vm.borderRadius
    }
  }, [_c('input', {
    staticClass: ["input"],
    style: _vm._inputStyle,
    attrs: {
      "type": _vm.type_,
      "value": _vm.value,
      "autofocus": _vm.autofocus,
      "maxlength": _vm.maxlength,
      "returnKeyType": _vm.returnKeyType,
      "singleline": _vm.singleline,
      "max": _vm.max,
      "min": _vm.min,
      "upriseOffset": _vm.upriseOffset,
      "hideDoneButton": _vm.hideDoneButton,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.input
    }
  }), (_vm.isShowRight) ? _c('div', {
    staticClass: ["right"],
    style: {
      backgroundColor: _vm._inputStyle.backgroundColor
    }
  }, [(_vm._isShowClear && _vm._isColmo) ? _c('dof-iconfont', {
    staticClass: ["icon"],
    attrs: {
      "code": '\u4725',
      "size": 48,
      "color": _vm._isColmo ? '#78797A' : '#1E2E37'
    },
    on: {
      "dofIconFontClicked": _vm.handleClear
    }
  }) : _vm._e(), (_vm._isShowClear && !_vm._isColmo) ? _c('image', {
    staticClass: ["clearImg"],
    attrs: {
      "src": _vm.iconImg.empty
    },
    on: {
      "click": _vm.handleClear
    }
  }) : _vm._e(), (_vm.isShowPWDIcon && _vm._isColmo) ? _c('dof-iconfont', {
    staticClass: ["icon"],
    attrs: {
      "code": _vm.PWDIcon,
      "size": 48,
      "color": _vm._isColmo ? '#78797A' : '#1E2E37'
    },
    on: {
      "dofIconFontClicked": _vm.handleTogglePWD
    }
  }) : _vm._e(), (_vm.isShowPWDIcon && !_vm._isColmo) ? _c('image', {
    staticClass: ["PWDImg"],
    attrs: {
      "src": _vm.PWDImg
    },
    on: {
      "click": _vm.handleTogglePWD
    }
  }) : _vm._e(), _vm._t("right")], 2) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-6078d0a7!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-input/index.vue
// module id = 621
// module chunks = 0 1